import { Row } from '@tanstack/react-table';

import { TripListRead, TripRead } from 'src/common/external/bambi-api/bambiApi';

export function getRowClassName(row: Row<TripListRead | TripRead>): string {
  const trip = row.original;
  if (trip.is_cancellation_requested) {
    return 'bg-red-50';
  }

  if (trip.is_will_call && !trip.is_will_call_activated) {
    return 'bg-purple-100';
  }

  return '';
}
